define('blocks/goto/goto',['require'],function (require) {
  (function(){
    var $body = $('body');

    $body.on('click', '[data-target="goto"]', function(e) {
        var target = $(this).attr('href');
        var $block = $body.find(target);

      $('html, body').animate({
          scrollTop: $block.offset().top
      }, 400);

      e.preventDefault();
    });
  })();

});

